import _ from 'lodash';
import Constants from '../../../common/Constants';

const getTypeMessage = {
    [Constants.ASIA_BETSLIP_TYPES.SINGLE]: 'single',
    [Constants.ASIA_BETSLIP_TYPES.PARLAY]: 'parlay',
    [Constants.ASIA_BETSLIP_TYPES.TEASER]: 'teaser',
}

const EVENT_NAME = 'placeBet';
const MSG_CODE = 'accepted';
const KEY_LOG_ERROR = '[iframePlaceBetMessage]';

/**
 * Sends a postMessage to the parent frame when a bet is placed
 * 
 * @example Single bet: { betId: "123", sportId: "29", sportName: "Soccer", betType: "single", ... }
 * @example Multiple single bets: [{ betId: "123", sportId: "29", betType: "single", ... }, { betId: "124", sportId: "30", betType: "single", ... }]
 * @example Parlay (includes Roubin): { betId: "456", betType: "parlay" }
 * @example Teaser: { betId: "789", betType: "teaser" }
 */

export const sendPlaceBetMessage = (betData, isLive = false) => {
	if (!(window.env || {}).enablePostMessagePlaceBet) return

    if (!window.parent || window.parent === window) {
        return;
    }

    if (!betData || (!isLive && (!_.isArray(betData.response) || _.isEmpty(betData.response)))) {
        return;
    }

    const { response, singleBets, betType } = betData;


    let msgData;

    switch (betType) {
        case Constants.ASIA_BETSLIP_TYPES.SINGLE:
            msgData = buildSingleBetData(response, singleBets, isLive);
            break;
        case Constants.ASIA_BETSLIP_TYPES.PARLAY:
            msgData = buildParlayBetData(response);
            break;
        case Constants.ASIA_BETSLIP_TYPES.TEASER:
            msgData = buildTeaserBetData(response);
            break;
        default:
            console.error(`${KEY_LOG_ERROR} Unknown bet type:`, betType);
            return;
    }

    if (!msgData || (_.isArray(msgData) && _.isEmpty(msgData))) {
        console.error(`${KEY_LOG_ERROR} No valid data to send`);
        return;
    }

    const message = {
        event: EVENT_NAME,
        msgCode: MSG_CODE,
        msgData: msgData
    };

    window.parent.postMessage(message, '*');
};

const buildSingleBetData = (responseBets, singleBets, isLive) => {
    const betDataArray = _.chain(isLive ? singleBets : responseBets)
        .map(bet => {
            const betId = _.get(bet, 'betId');

            if (!isLive && !isValidBetId(betId)) {
                console.error(`${KEY_LOG_ERROR} Invalid betId for single bet:`, betId);
                return null;
            }

            const singleBet = findSingleBetByOddsId(singleBets, _.get(bet, 'oddsId'));

            if (!singleBet) {
                console.error(`${KEY_LOG_ERROR} Cannot find singleBet for oddsId:`, _.get(bet, 'oddsId'));
                return null;
            }

            return buildBetDataObject(bet, singleBet);
        })
        .filter(bet => !_.isNull(bet))
        .value();

    if (_.isEmpty(betDataArray)) {
        return null;
    }

    return betDataArray.length === 1 ? betDataArray[0] : betDataArray;
};

const buildParlayBetData = (responseBets) => {
    if (_.isEmpty(responseBets)) {
        console.error(`${KEY_LOG_ERROR} No response bets found`);
        return null;
    }

    const firstBet = _.first(responseBets);
    const betId = _.get(firstBet, 'betId');

    if (!isValidBetId(betId)) {
        console.error(`${KEY_LOG_ERROR} Invalid betId for parlay bet:`, betId);
        return null;
    }

    return {
        betId: betId,
        betType: getTypeMessage[Constants.ASIA_BETSLIP_TYPES.PARLAY]
    };
};

const buildTeaserBetData = (responseBets) => {
    if (_.isEmpty(responseBets)) {
        console.error(`${KEY_LOG_ERROR} No response bets found`);
        return null;
    }

    const firstBet = _.first(responseBets);
    const betId = _.get(firstBet, 'betId');

    if (!isValidBetId(betId)) {
        console.error(`${KEY_LOG_ERROR} Invalid betId for teaser bet:`, betId);
        return null;
    }

    return {
        betId: betId,
        betType: getTypeMessage[Constants.ASIA_BETSLIP_TYPES.TEASER]
    };
};

const buildBetDataObject = (responseBet, singleBet) => {
    return {
        betId: _.get(responseBet, 'wagerId', ''),
        sportId: _.get(singleBet, 'sportId', ''),
        sportName: _.get(singleBet, 'sport', ''),
        competitionId: "",
        competitionName: "",
        eventId: _.get(singleBet, 'eventId', ''),
        eventName: _.get(singleBet, 'eventName','') || `${_.get(singleBet, 'homeTeam', '')} vs ${_.get(singleBet, 'awayTeam', '')}`,
        marketId: "",
        marketName: "",
        selectionId: "",
        selectionName: "",
        handicap: _.get(responseBet, 'psBetVO.handicap', '') || _.get(singleBet, 'handicap', ''),
        odds: _.get(responseBet, 'odds', '') || _.get(responseBet, 'psBetVO.price', '') || _.get(singleBet, 'odds', ''),
        stake: _.get(responseBet, 'psBetVO.risk', '') || _.get(singleBet, 'stake', '') || _.get(singleBet, 'risk', ''),
        betType: 'single',
        marketStartTime: ""
    };
};

const isValidBetId = (betId) => {
    if (_.isNil(betId)) {
        return false;
    }

    const numericBetId = _.toNumber(betId);
    return _.isFinite(numericBetId) && numericBetId > 0;
};

const findSingleBetByOddsId = (singleBets, oddsId) => {
    if (!_.isArray(singleBets)) {
        return null;
    }
    return _.find(singleBets, bet => _.get(bet, 'oddsId') === oddsId) || null;
};


// WEBPACK FOOTER //
// ./src/app/components/BetslipComponent/AsiaView/PostMessagePlaceBetsUtil.js